import { render, staticRenderFns } from "./DirectReceiveAcceptPopup.vue?vue&type=template&id=e4764576"
import script from "./DirectReceiveAcceptPopup.vue?vue&type=script&lang=js"
export * from "./DirectReceiveAcceptPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports